import { Input } from "antd";
import { TableProps } from "antd/es/table";
import { useEffect } from "react";
import SearchIcon from "../../../../assets/icons/SearchIcon";
import ManageWorkStation from "../../../../components/Settings/WorkStation/ManageWorkStation";
import CustomTable from "../../../../components/ui/CustomTable";
import {
  useGetWorkStationsQuery,
  useUpdateWorkStationStatusMutation,
} from "../../../../features/workStation/workStationApi";
import useDebounce from "../../../../hooks/useDebounce";
import useError from "../../../../hooks/useError";
import useModal from "../../../../hooks/useModal";
import useTable from "../../../../hooks/useTable";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import { toast } from "../../../../lib/toast";
import { WorkStationData } from "../../../../types/workStation";
import { countParPageSerialNumber } from "../../../../utils/number";
import { capitalize } from "../../../../utils/string";
import { addKeyInArray, skipData } from "../../../../utils/utils";
import { SettingStatus } from "../Department/Department";

enum WorkStationStatus {
  "Inactive",
  "Active",
}

export default function WorkStation() {
  const { open, handleClose, handleOpen } = useModal();
  const { keyword, handleInputChange } = useDebounce();
  const { page, limit, handlePagination, handleLimit, resetPagination } =
    useTable();
  const [
    updateWorkStationStatus,
    {
      isSuccess: isStatusUpdateSuccess,
      isError: isStatusUpdateError,
      error: statusUpdateError,
    },
  ] = useUpdateWorkStationStatusMutation();
  const { isLoading, isError, error, data } = useGetWorkStationsQuery({
    params: {
      limit,
      skip: skipData(page, limit),
      ...(keyword ? { search: keyword } : {}),
    },
  });

  useError(isError, error, "Get work station data fail");
  useError(
    isStatusUpdateError,
    statusUpdateError,
    "Work station status update fail"
  );

  const columns: TableProps<WorkStationData>["columns"] = [
    {
      title: "#SL",
      align: "center",
      width: 60,
      render: (_, __, index) => countParPageSerialNumber(page, limit, index),
    },
    {
      title: "Work Station Name",
      dataIndex: "name",
    },
    // {
    //   title: "Abbreviation",
    //   dataIndex: "abbreviation",
    //   render: (val) => val || "n/a",
    // },
    {
      title: "Total Employees",
      dataIndex: "employee_count",
      render: (val) => val ?? 0,
    },
    {
      title: "Status",
      dataIndex: "is_published",
      render: (val) => (
        <div className="flex items-center gap-2">
          <span className={SettingStatus[val ? "active" : "inactive"]}>
            {capitalize(val ? "active" : "inactive")}
          </span>
        </div>
      ),
    },
    // {
    //   title: "Action",
    //   width: 200,
    //   render: (val) => (
    //     <Space size={8}>
    //       <Button
    //         className="action-button"
    //         size="small"
    //         icon={<EditIcon />}
    //         onClick={() =>
    //           handleOpen({
    //             type: "UPDATE",
    //             data: val?.id,
    //           })
    //         }
    //       />
    //       <Space size={4}>
    //         <Switch
    //           className="custom-switch"
    //           checked={val?.is_published === 1}
    //           onChange={() =>
    //             updateWorkStationStatus({
    //               id: val?.id,
    //               body: {
    //                 is_published: val?.is_published === 0 ? 1 : 0,
    //               },
    //             })
    //           }
    //           // disabled={isStatusUpdateLoading}
    //         />
    //         <span className="text-header text-sm font-medium">
    //           {WorkStationStatus[val?.is_published]}
    //         </span>
    //       </Space>
    //     </Space>
    //   ),
    // },
  ];

  // success toast message
  useEffect(() => {
    if (isStatusUpdateSuccess) {
      toast("success", "Work station status updated successfully");
    }
  }, [isStatusUpdateSuccess]);

  return (
    <SidebarLayout title="Work Station List">
      <CustomTable
        loading={isLoading}
        limit={limit}
        page={page}
        columns={columns}
        total={data?.data?.totalLength}
        dataSource={addKeyInArray(data?.data?.workStations)}
        handleLimit={handleLimit}
        handlePagination={handlePagination}
        filterSection={
          <>
            <Input
              suffix={<SearchIcon />}
              placeholder="Search by name"
              onChange={(val) => {
                handleInputChange(val);
                resetPagination();
              }}
            />
            {/* <Button
              icon={<AddIcon />}
              type="primary"
              className="sm-button"
              onClick={() =>
                handleOpen({
                  type: "ADD",
                })
              }
            >
              Add Work Station
            </Button> */}
          </>
        }
      />

      {(open.type === "ADD" || open.type === "UPDATE") && (
        <ManageWorkStation
          open={open.open}
          type={open.type}
          data={open.data}
          handleClose={handleClose}
        />
      )}
    </SidebarLayout>
  );
}
